import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import _ from "lodash";
import moment from "moment";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  outreachCreateModal,
  fetchAssociated,
  sendNotificationDirect,
  sendNotificationScheduled,
  openChooseUserModal,
} from "DashboardOutreachAction";
import {
  validateUrl,
  COMMON_FAIL_MESSAGE,
  DISPLAY_LOCAL_DATE_FORMAT,
} from "Constants";
import MaxCharacterObject from "MaxCharacterObject";
import ImageCropper from "ImageCropper";
import ChooseUsersDialog from "./chooseusers.js";
import LocaleStrings from "Languages";
import BetaFeature from "BetaFeature";

var MAXLENOBJ = {};
class DashboardOutreachCreate extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = { loading: false, imagePreviewUrl: "", speceficUsers: [] };
  }

  componentDidMount() {
    MAXLENOBJ = MaxCharacterObject.dashboard.outreach; // filter This form name object With route
  }

  close = () => {
    this.props.outreachCreateModal({ show: false });
    this.props.reset();
  };

  onSubmitForm = (values) => {
    console.log("values :- ", values);
    var { session, usersCategoryWise, eventDetails } = this.props;
    var { speceficUsers } = this.state;
    let totalUsersList = usersCategoryWise.allusers;
    let selectedUsers = [];

    if (values.redirecttype) {
      if (values.redirecttype === "internal" && values.associatedvalues) {
        values.redirectto = values.associatedvalues.values.link;
        values.redirectvalue = values.associatedvalues.values.value;
      } else if (values.redirecttype === "external" && values.externallink) {
        values.redirectto = values.redirecttype;
        values.redirectvalue = values.externallink;
      }
    }

    // console.log("final values :- ", values);

    if (values.category === "specific") {
      selectedUsers = speceficUsers;
    } else if (values.category !== "specific" && values.category !== "all") {
      var matchCat = _.filter(usersCategoryWise.data, function (obj) {
        return obj.id == values.category;
      });

      if (matchCat.length > 0) {
        selectedUsers = matchCat[0].appusers;
      }
    } else {
      selectedUsers = totalUsersList;
    }
    // console.log("selectedUsers: ", selectedUsers);

    var title = "";
    var message = "";
    if (values.option === "push") {
      title = LocaleStrings.outreach_send_push_notification;
      message =
        values.sendtime === "scheduled"
          ? LocaleStrings.outreach_send_push_notification_subtitle2
          : LocaleStrings.outreach_send_push_notification_subtitle1;
    } else {
      title = LocaleStrings.outreach_send_push_and_email_notification;
      message =
        LocaleStrings.outreach_send_push_and_emails_notification_subtitle1;
    }
    // console.log("Final values :- ", values);

    if (values.sendtime === "scheduled") {
      let scheduleDate = values.scheduledate;
      var outreachSenddate =
        typeof scheduleDate === "string"
          ? moment(scheduleDate, `${DISPLAY_LOCAL_DATE_FORMAT} HH:mm`).format(
              "YYYY-MM-DD HH:mm"
            )
          : moment(scheduleDate).format("YYYY-MM-DD HH:mm");
      // var outreachSenddate = moment(values.scheduledate).format(
      //   "YYYY-MM-DD HH:mm"
      // );
      var outreachScheduleDateTime = `${outreachSenddate}`;

      let eventtimezone = "";
      if (eventDetails) {
        eventtimezone = eventDetails.eventtimezone;
      }

      var curTime = moment().tz(eventtimezone);
      curTime = curTime.format("YYYY-MM-DD HH:mm");

      if (outreachScheduleDateTime < curTime) {
        this.props.showError(
          LocaleStrings.outreach_message_error_add_future_date
        );
        return false;
      }

      values.scheduledate = outreachScheduleDateTime;
      console.log("final values :- ", values);

      confirmAlert({
        title: title,
        message: message,
        confirmLabel: LocaleStrings.button_ok,
        cancelLabel: LocaleStrings.button_cancel,
        buttons: [
          {
            label: LocaleStrings.button_ok,
            onClick: () => {
              this.setState({ loading: true });
              this.props.sendNotificationScheduled(
                session,
                values,
                selectedUsers,
                (response) => {
                  this.setState({ loading: false });
                  if (response.success === 0) {
                    this.props.showError(COMMON_FAIL_MESSAGE);
                  } else if (response.success == 2) {
                    this.props.showError(
                      LocaleStrings.outreach_message_notification_no_recipients
                    );
                  } else {
                    this.props.showSuccess(
                      LocaleStrings.outreach_message_notification_sscheduled_success
                    );
                    this.close();
                    this.props.finishOperationsCallback();
                  }
                }
              );
            },
          },
          {
            label: LocaleStrings.button_cancel,
            onClick: () => {},
          },
        ],
      });
    } else {
      confirmAlert({
        title: title,
        message: message,
        confirmLabel: LocaleStrings.button_ok,
        cancelLabel: LocaleStrings.button_cancel,
        buttons: [
          {
            label: LocaleStrings.button_ok,
            onClick: () => {
              this.setState({ loading: true });
              this.props.sendNotificationDirect(
                session,
                values,
                selectedUsers,
                (response) => {
                  this.setState({ loading: false });
                  if (response.success === 0) {
                    this.props.showError(COMMON_FAIL_MESSAGE);
                  } else if (response.success == 2) {
                    this.props.showError(
                      LocaleStrings.outreach_message_notification_no_recipients
                    );
                  } else {
                    this.props.showSuccess(
                      LocaleStrings.outreach_message_notification_sent
                    );
                    this.close();
                    this.props.finishOperationsCallback();
                  }
                }
              );
            },
          },
          {
            label: LocaleStrings.button_cancel,
            onClick: () => {},
          },
        ],
      });
    }
  };

  onImageSave = (img) => {
    this.setState({ imagePreviewUrl: img == "" ? "" : img });
    this.props.autofill("image", img == "" ? "" : img);
  };

  onImageChange = (imageAvailable) => {};

  handleRedirectType = (e) => {
    var val = e.target.value;
    // console.log("val :- ", val);

    this.props.autofill("associatedvalues", "");
    this.props.autofill("externallink", "");
  };

  fetchAutocompleteSuggestions = (e, callback) => {
    var val = e;
    // console.log("val :- ", val);

    // speaker/sponsor/exhibitor/survey/session/community/poll/news.  internals links //
    this.props.fetchAssociated(
      this.props.session,
      { search: val },
      (response) => {
        // console.log("response :- ", response);
        var searchData = response.resource;
        var options = [];

        if (searchData.speaker) {
          var speaker = [];
          searchData.speaker.map((item) => {
            speaker.push({
              values: { value: item.speakerid, link: "speaker" },
              label: `${item.firstname} ${item.lastname}`,
            });
          });
          options.push({ label: "Speaker", options: speaker });
        }
        if (searchData.sponsor) {
          var sponsor = [];
          searchData.sponsor.map((item) => {
            sponsor.push({
              values: { value: item.sponsorid, link: "sponsor" },
              label: `${item.name}`,
            });
          });
          options.push({ label: "Sponsor", options: sponsor });
        }
        if (searchData.exhibitor) {
          var exhibitor = [];
          searchData.exhibitor.map((item) => {
            exhibitor.push({
              values: { value: item.exhibitorid, link: "exhibitor" },
              label: `${item.name}`,
            });
          });
          options.push({ label: "Exhibitor", options: exhibitor });
        }
        if (searchData.survey) {
          var survey = [];
          searchData.survey.map((item) => {
            survey.push({
              values: { value: item.formid, link: "survey" },
              label: `${item.formname}`,
            });
          });
          options.push({ label: "Survey", options: survey });
        }
        if (searchData.session) {
          var session = [];
          searchData.session.map((item) => {
            session.push({
              values: { value: item.sessionid, link: "session" },
              label: `${item.title}`,
            });
          });
          options.push({ label: "Session", options: session });
        }
        if (searchData.community) {
          var community = [];
          searchData.community.map((item) => {
            community.push({
              values: { value: item.communitycategoryid, link: "community" },
              label: `${item.categoryname}`,
            });
          });
          options.push({ label: "Community", options: community });
        }
        if (searchData.poll) {
          var poll = [];
          searchData.poll.map((item) => {
            poll.push({
              values: { value: item.pollid, link: "poll" },
              label: `${item.question}`,
            });
          });
          options.push({ label: "Poll", options: poll });
        }
        if (searchData.news) {
          var news = [];
          searchData.news.map((item) => {
            news.push({
              values: { value: item.newsid, link: "news" },
              label: `${item.newstitle}`,
            });
          });
          options.push({ label: "News", options: news });
        }

        // console.log("options :- ", options);
        callback(options);
      }
    );
  };

  onOptionChange = (e) => {
    var opt = e.target.value;
    // console.log("opt :- ", opt);

    this.props.autofill("sendtime", "now");
    this.props.autofill("scheduledate", "");
  };

  onUserCategoryChange = (e) => {
    var cat = e.target.value;
    // console.log("cat :- ", cat);

    if (cat === "specific") {
      this.props.openChooseUserModal(true);
    } else {
      this.setState({ speceficUsers: [] });
    }
  };

  onUserSpeceficCategory = () => {
    // console.log("specific called");

    this.props.autofill("category", "specific");
    this.props.openChooseUserModal(true);
  };

  targetUserCategory = (cat) => {
    this.props.autofill("category", cat);
  };

  speceficUsrsCallback = (users) => {
    this.setState({ speceficUsers: users });
  };

  _renderCategory = () => {
    let { usersCategoryWise } = this.props;

    return _.map(usersCategoryWise.data, (obj, index) => {
      return obj.appusers.length > 0 ? (
        <Field
          key={`cat_key_${index}`}
          name="category"
          label={obj.groupname + " ( " + obj.appusers.length + " )"}
          type="radio"
          component={this.renderFieldRadio}
          value={obj.id}
          onChange={this.onUserCategoryChange}
        />
      ) : (
        ""
      );
    });
  };

  render() {
    var {
      handleSubmit,
      pristine,
      submitting,
      invalid,
      DashboardNotificationModal,
      usersCategoryWise,
      showChooseUserModal,
      option,
      redirecttype,
      sendtime,
      eventDetails,
      targettype,
    } = this.props;
    var { imagePreviewUrl, speceficUsers } = this.state;
    // console.log("eventDetails.eventtimezone :- ", eventDetails.eventtimezone);
    // console.log("speceficUsers :- ", speceficUsers);
    // console.log("targettype :- ", targettype);
    // console.log("sendtime :- ", sendtime);

    let curTimezone = "";
    let eventtimezone = "";
    if (Object.keys(eventDetails).length > 0) {
      curTimezone = moment()
        .tz(this.props.eventDetails.eventtimezone)
        .format("Z z");
      eventtimezone = this.props.eventDetails.eventtimezone;
    }

    let userCategories = [
      {
        name:
          usersCategoryWise && usersCategoryWise.allusers
            ? `${LocaleStrings.outreach_form_label_option_1} ( ${usersCategoryWise.allusers.length} )`
            : LocaleStrings.outreach_form_label_option_1,
        value: "all",
      },
    ];
    _.map(usersCategoryWise.data, (obj) => {
      userCategories.push({
        name: obj.groupname + " ( " + obj.appusers.length + " )",
        value: obj.id,
      });
    });
    userCategories.push({
      name: LocaleStrings.outreach_form_target_option_custom,
      value: "specific",
    });

    return (
      <div>
        <Modal
          className="modal-container"
          show={DashboardNotificationModal.show ? true : false}
          onHide={this.close}
          animation={true}
          keyboard={false}
          backdrop="static"
          dialogClassName="modal-lg"
        >
          <form
            className="basic-form"
            onSubmit={handleSubmit(this.onSubmitForm)}
            encType="multipart/form-data"
          >
            <Modal.Header>
              <div className="import-modal-title">
                {LocaleStrings.outreach_send_push_notification}
                <span className="ps-1">
                  <BetaFeature />
                </span>
              </div>
              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={() => this.close()}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                  alt="close"
                />
              </button>
            </Modal.Header>
            <Modal.Body>
              <div className="form-group row">
                <div className="col-md-12">
                  <label className="control-label-top">
                    {LocaleStrings.outreach_send_option}
                  </label>
                </div>
                <div className="col-md-12 vertical-align-center">
                  <Field
                    name="option"
                    label={LocaleStrings.outreach_send_option_option1}
                    component={this.renderFieldRadio}
                    type="radio"
                    value="push"
                    onChange={this.onOptionChange}
                  />
                  <Field
                    name="option"
                    label={LocaleStrings.outreach_send_option_option2}
                    component={this.renderFieldRadio}
                    type="radio"
                    value="push_email"
                    onChange={this.onOptionChange}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <label className="control-label-top">
                    {LocaleStrings.outreach_form_label_image}
                  </label>
                  <ImageCropper
                    displaySize={{ width: 230, height: 230 }} // For image display style
                    requiredSize={{ width: 200, height: 200 }} // For image size required validation
                    cropperSize={{ width: 180, height: 180 }} // Cropper display size. Note its add 50px for padding
                    border={10}
                    onImageSave={this.onImageSave}
                    onImageChange={this.onImageChange}
                    imagepath={imagePreviewUrl}
                    imageType="jpg"
                    className="drop-zone-area-custom-image"
                    insideImage="../../style/images/dummy-image-fill@3x.png"
                    insideImageStyle={{
                      width: 36,
                      height: 36,
                    }}
                    insideText={LocaleStrings.outreach_form_ph_image}
                  />
                  <Field
                    name="image"
                    type="text"
                    component={this.renderHiddenFieldText}
                  />
                </div>
                <div className="col-md-8">
                  <Field
                    name="title"
                    label={LocaleStrings.outreach_form_label_title}
                    placeholder={LocaleStrings.outreach_form_ph_title}
                    type="text"
                    mandatory="true"
                    component={this.renderFieldText}
                    labelposition={LABEL_POSITION_TOP}
                    maxlength={MAXLENOBJ.title ? MAXLENOBJ.title : ""}
                  />
                  <Field
                    name="content"
                    label={LocaleStrings.outreach_form_label_content}
                    placeholder={
                      LocaleStrings.outreach_form_label_content_placeholder
                    }
                    mandatory="true"
                    component={this.renderFieldTextarea}
                    labelposition={LABEL_POSITION_TOP}
                    maxlength={MAXLENOBJ.content ? MAXLENOBJ.content : ""}
                  />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-12">
                  <label className="control-label-top">
                    {LocaleStrings.outreach_form_label_target}
                  </label>
                </div>
                <div className="col-md-12">
                  <div className="vertical-align-center gap-3">
                    {/* <Field
                      name="category"
                      label={
                        usersCategoryWise && usersCategoryWise.allusers
                          ? `${LocaleStrings.outreach_form_label_option_1} ( ${usersCategoryWise.allusers.length} )`
                          : LocaleStrings.outreach_form_label_option_1
                      }
                      type="radio"
                      component={this.renderFieldRadio}
                      value="all"
                      onChange={this.onUserCategoryChange}
                    />
                    {this._renderCategory()}
                    <Field
                      name="category"
                      label={LocaleStrings.outreach_form_target_option_custom}
                      type="radio"
                      component={this.renderFieldRadio}
                      value="specific"
                      onChange={this.onUserCategoryChange}
                    /> */}

                    <Field
                      name="category"
                      // label={LocaleStrings.outreach_form_label_target}
                      component={this.renderSelect}
                      mandatory="true"
                      labelposition={LABEL_POSITION_TOP}
                      opts={userCategories}
                      onChange={this.onUserCategoryChange}
                    />

                    {targettype === "specific" && speceficUsers.length > 0 ? (
                      <div
                        className="form-group custom-text1-theme-bold text-decoration-underline pointer"
                        onClick={this.onUserSpeceficCategory}
                      >
                        +{" "}
                        {_.replace(
                          LocaleStrings.outreach_form_target_text_custom_selected,
                          "#total",
                          speceficUsers.length
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <label className="control-label-top">
                    {LocaleStrings.outreach_form_label_redirect}
                  </label>
                </div>
                <div className="col-md-2">
                  <div className="col-md-12">
                    <label className="control-label-top">
                      {LocaleStrings.default}
                    </label>
                  </div>
                  <div className="vertical-align-center">
                    <Field
                      name="redirecttype"
                      label="None"
                      type="radio"
                      component={this.renderFieldRadio}
                      formdiv="mt-8"
                      value="null"
                      onChange={this.handleRedirectType}
                    />
                    <div className="custom-text1-primary-bold ml-10">
                      {LocaleStrings.or}
                    </div>
                  </div>
                </div>
                <div className="col-md-5 vertical-align-center">
                  <Field
                    name="redirecttype"
                    type="radio"
                    component={this.renderFieldRadio}
                    value="internal"
                    onChange={this.handleRedirectType}
                  />
                  <Field
                    name="associatedvalues"
                    label={LocaleStrings.outreach_form_label_internal}
                    placeholder={LocaleStrings.outreach_form_ph_internal}
                    labelinfo={LocaleStrings.outreach_form_labelinfo_internal}
                    component={this.renderAutoCompleteAsync}
                    mandatory="true"
                    loadOptions={this.fetchAutocompleteSuggestions}
                    labelposition={LABEL_POSITION_TOP}
                    disabled={redirecttype === "internal" ? false : true}
                  />
                  <div className="custom-text1-primary-bold ml-20 mt-20">
                    {LocaleStrings.or}
                  </div>
                </div>
                <div className="col-md-5 vertical-align-center">
                  <Field
                    name="redirecttype"
                    type="radio"
                    component={this.renderFieldRadio}
                    value="external"
                    onChange={this.handleRedirectType}
                  />
                  <Field
                    name="externallink"
                    label={LocaleStrings.outreach_form_label_external}
                    placeholder={LocaleStrings.outreach_form_ph_external}
                    type="text"
                    component={this.renderFieldText}
                    labelposition={LABEL_POSITION_TOP}
                    disabled={redirecttype === "external" ? false : true}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <label className="control-label-top">
                    {LocaleStrings.outreach_form_label_sending_type}
                  </label>
                  <div className="vertical-align-center gap-3">
                    <Field
                      name="sendtime"
                      label={
                        LocaleStrings.outreach_form_label_sending_type_option1
                      }
                      component={this.renderFieldRadio}
                      type="radio"
                      value="now"
                    />
                    {option === "push" ? (
                      <Field
                        name="sendtime"
                        label={
                          LocaleStrings.outreach_form_label_sending_type_option2
                        }
                        component={this.renderFieldRadio}
                        type="radio"
                        value="scheduled"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="col-md-8">
                  {sendtime === "scheduled" ? (
                    <Field
                      name="scheduledate"
                      label={LocaleStrings.outreach_form_label_shcedule_date}
                      component={this.renderDateTimePicker}
                      mandatory="true"
                      labelposition={LABEL_POSITION_TOP}
                      minDate={new Date()}
                    />
                  ) : (
                    ""
                  )}
                </div>
                {sendtime === "scheduled" ? (
                  <div className="col-md-12">
                    <div className="form-group- custom-text1-secondary-medium">
                      [{`${eventtimezone} - (${curTimezone})`}]
                    </div>
                    <span>
                      {LocaleStrings.note} :-{" "}
                      {LocaleStrings.outreach_form_note1}
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="button"
                className="btn btn-custom-white"
                onClick={this.close}
              >
                {LocaleStrings.button_close}
              </Button>
              <Button
                className="btn btn-custom-blue ml-10"
                loading={this.state.loading}
                disabled={pristine || invalid || submitting}
                type="submit"
              >
                {LocaleStrings.button_send}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>

        {showChooseUserModal ? (
          <ChooseUsersDialog
            speceficUsers={speceficUsers}
            userSelectionCallback={this.speceficUsrsCallback}
            categoryCallback={this.targetUserCategory}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

const selector = formValueSelector("DashboardNotificationForm");

function mapStateToProps(state, ownProps) {
  var init = {
    option: "push",
    category: "all",
    redirecttype: "null",
    sendtime:
      ownProps.selectedTab && ownProps.selectedTab == 2 ? "scheduled" : "now",
  };
  return {
    session: state.session,
    DashboardNotificationModal: state.DashboardNotificationModal,
    usersCategoryWise: state.DashboardUserCategoryWise,
    eventDetails: state.userEventDetails,
    showChooseUserModal: state.showChooseUserModal,
    initialValues: init,

    option: selector(state, "option"),
    targettype: selector(state, "category"),
    redirecttype: selector(state, "redirecttype"),
    sendtime: selector(state, "sendtime"),
  };
}

var validate = (values) => {
  var errors = {};
  var title = values["title"];
  var content = values["content"];
  var redirecttype = values["redirecttype"];
  var externallink = values["externallink"];
  var sendtime = values["sendtime"];
  var scheduledate = values["scheduledate"];
  var maxLengthFields = ["title", "content"];

  if (!title || title.trim() === "") {
    errors["firstname"] = LocaleStrings.required;
  }
  if (!content || content.trim() === "") {
    errors = {
      content: LocaleStrings.outreach_validation_notification_required,
    };
  }
  if (
    redirecttype === "external" &&
    externallink &&
    !validateUrl(externallink)
  ) {
    errors["externallink"] = LocaleStrings.invalid_url;
  }
  if (sendtime === "scheduled" && !scheduledate) {
    errors["scheduledate"] = LocaleStrings.required;
  }
  /*** Max Length Validation ***/
  maxLengthFields.forEach((field) => {
    if (values[field] && MAXLENOBJ) {
      if (values[field].length > MAXLENOBJ[field]) {
        errors[field] = LocaleStrings.max_characters_left + MAXLENOBJ[field];
      }
    }
  });

  return errors;
};

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  outreachCreateModal,
  fetchAssociated,
  openChooseUserModal,
  sendNotificationDirect,
  sendNotificationScheduled,
})(
  reduxForm({
    validate,
    form: "DashboardNotificationForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(DashboardOutreachCreate)
);
